import { API_BASE_URL } from "@/shared/config/site";

export interface RegisterPayload {
  email: string;
  password: string;
  telegram?: string;
}

export async function registerPartner(payload: RegisterPayload): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/rest/public/affiliate/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: payload.email, password: payload.password, telegram: payload.telegram || undefined }),
  });

  const data = (await res.json().catch(() => ({}))) as { message?: string };

  if (!res.ok) {
    throw new Error(data.message ?? "Произошла ошибка. Попробуйте ещё раз.");
  }
}
